import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  listenToShortGuestReservations,
  upsertShortstayReservation,
} from "../../../../redux/shortstayReservationSlice";

const UpdateGuestRescheduleShortstay: React.FC = () => {
  const {
    guestId,
    listingId,
    reservationId,
  } = useParams<{
    guestId: string;
    listingId: string;
    reservationId: string;
  }>();

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const reservations = useSelector(
    (state: RootState) => state.shortstayReservations.guestReservations
  );
  const booking = reservations.find(res => res.id === reservationId);

  const [updating, setUpdating] = useState(false);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    if (guestId) {
      dispatch(listenToShortGuestReservations(guestId));
    }
  }, [dispatch, guestId]);

  const handleUpdate = async () => {
    if (!booking?.id || !booking.checkIn || !booking.checkOut) return;
    setUpdating(true);

    await dispatch(
      upsertShortstayReservation({
      paymentId: booking.paymentId,   // ✅ required by the slice
        updates: {
          checkIn: booking.checkIn,
          checkOut: booking.checkOut,
          reservationStatus: "confirmed",
        },
      })
    );

    setUpdating(false);
    setUpdated(true);

    setTimeout(() => {
      navigate(`/shortbookings/${guestId}`);
    }, 1800);
  };

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("default", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Update Confirmed</h2>

      <div style={styles.card}>
        <p><strong>Reservation:</strong> {reservationId}</p>
        <p><strong>Listing:</strong> {listingId}</p>

        <hr style={styles.hr} />

        <h3 style={styles.subTitle}>Updated Dates</h3>
        <p><strong>New Check-In:</strong> {formatDate(booking?.checkIn)}</p>
        <p><strong>New Check-Out:</strong> {formatDate(booking?.checkOut)}</p>

        <p style={{ color: "#0f0", marginTop: 16 }}>
          ✅ Your reservation has been updated successfully.
        </p>

        <button
          onClick={handleUpdate}
          disabled={updating || updated}
          style={styles.confirmBtn}
        >
          {updating ? "Updating..." : updated ? "Redirecting..." : "Finalize"}
        </button>
      </div>
    </div>
  );
};

export default UpdateGuestRescheduleShortstay;

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    background: "#000",
    color: "#fff",
    minHeight: "100vh",
    padding: "80px 20px 140px",
    fontFamily: "sans-serif",
  },
  title: {
    fontSize: "1.8rem",
    textAlign: "center",
    marginBottom: 20,
  },
  card: {
    background: "#111",
    borderRadius: 16,
    padding: 24,
    maxWidth: 500,
    margin: "0 auto",
    border: "1px solid #bf9b30",
  },
  subTitle: {
    fontSize: "1.2rem",
    marginBottom: 10,
  },
  hr: {
    border: "none",
    borderTop: "1px solid #333",
    margin: "16px 0",
  },
  confirmBtn: {
    marginTop: 20,
    padding: "12px 20px",
    borderRadius: 30,
    border: "none",
    fontWeight: 600,
    fontSize: 16,
    background: "linear-gradient(to right, #fff, #bf9b30)",
    color: "#000",
    cursor: "pointer",
    width: "100%",
  },
};
